module.exports = __webpack_public_path__ + "img/product_video51.b1f19784.jpg";